import { render } from "./PlayerManager.vue?vue&type=template&id=2733ee98&scoped=true"
import script from "./PlayerManager.vue?vue&type=script&lang=js"
export * from "./PlayerManager.vue?vue&type=script&lang=js"

import "./PlayerManager.vue?vue&type=style&index=0&id=2733ee98&scoped=true&lang=css"
import "./PlayerManager.vue?vue&type=style&index=1&id=2733ee98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2733ee98"]])

export default __exports__